<template>
  <div :id="isTextLongerThan250Characters ? 'pointerCursor' : ''" class="statusReportCard" @click="activateReadMore">
    <div id="Title">
      <h4>{{ cardContent.title }}</h4>
      <div class="dotWrapper">
        <div :class="{ redDot: semaphorLight[0].isRed, orangeDot: semaphorLight[1].isOrange, greenDot: semaphorLight[2].isGreen }"></div>
      </div>
    </div>

    <span v-if="!readMoreActivated"> {{ cardContent.content.slice(0, 250) }} </span>
    <p v-if="!readMoreActivated" class="readMoreDots">
      <i v-if="isTextLongerThan250Characters" class="bi bi-three-dots"></i>
    </p>
    <span v-if="readMoreActivated"> {{ cardContent.content }} </span>
  </div>
</template>

<script>
export default {
  name: 'StatusReportCard',
  props: {
    cardContent: {}
  },
  data() {
    return {
      readMoreActivated: false,
      semaphorLight: [
        { isRed: this.cardContent.status == 'severe' }, //eslint-disable-line
        { isOrange: this.cardContent.status == 'critical' }, //eslint-disable-line
        { isGreen: this.cardContent.status == 'good' } //eslint-disable-line
      ]
    }
  },

  computed: {
    isTextLongerThan250Characters() {
      return this.cardContent.content.length > 250
    }
  },

  methods: {
    activateReadMore() {
      if (!this.isTextLongerThan250Characters) {
        return
      }
      this.readMoreActivated = !this.readMoreActivated
    }
  }
}
</script>

<style scoped>
.statusReportCard {
  padding: 10px;
  border: solid 0 gray;
  border-radius: 10px;
  margin: 10px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
  transition: 0.3s;
  overflow-wrap: break-word;
  word-break: break-word;
  min-width: 0;
}

#pointerCursor {
  cursor: pointer;
}

#Title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: purple;
}

.readMoreDots {
  size: 40px;
}
</style>
